import { useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { Header, List, Loader, Segment } from 'semantic-ui-react'
import { ACTIVITY_DEFINITION, LESSON_DEFINITION } from '../../../query/activityQuery'
import { Trans } from 'react-i18next'
import { convertOrdinalToNum } from '../../../utils'

const EduLessonDetail = ({ slug }) => {
  const [lesson, setLesson] = useState()
  const [minimumGrade, setMinimumGrade] = useState()
  const [maximumGrade, setMaximumGrade] = useState()

  useEffect(() => {
    const grades = lesson?.grades
    if (grades && grades.length > 0) {
      setMinimumGrade(grades[0])
      setMaximumGrade(grades[1])
    }
  }, [lesson?.grades])

  const { loading } = useQuery(ACTIVITY_DEFINITION, {
    fetchPolicy: 'cache-and-network',
    variables: { slug },
    skip: !slug,
    onError (err) {
      console.error(err)
    },
    onCompleted (payload) {
      const { activity } = payload
      setLesson(activity)
    }
  })

  return (
    <Segment>
      <Header as='h2' textAlign='center'>{lesson?.name}</Header>
      {loading
        ? <Loader />
        : (
          <List style={{ color: 'white' }}>
            <List.Item>
              <b>Lesson Code:</b> {lesson?.id}
            </List.Item>
            <List.Item>
              <b>Duration:</b> {lesson?.duration}
            </List.Item>
            <List.Item>
              <b>Grade:</b>{` ${minimumGrade} - ${maximumGrade}`}
            </List.Item>
            <List.Item>
              <b>Compatible Robots:</b>
              <List.List>
                {lesson?.products && lesson.products.map(product => (
                  <List.Item key={product?.name}>{product?.name}</List.Item>))}
              </List.List>
            </List.Item>
          </List>)}
    </Segment>
  )
}

const NonEduLessonDetail = ({ slug }) => {
  const [lesson, setLesson] = useState()

  const { loading } = useQuery(LESSON_DEFINITION, {
    fetchPolicy: 'cache-and-network',
    variables: { slug },
    skip: !slug,
    onError (err) {
      console.error(err)
    },
    onCompleted (payload) {
      const { lesson } = payload
      setLesson(lesson)
    }
  })
  console.log('here', loading, lesson)
  const grades = convertOrdinalToNum(lesson?.tags?.grades).sort((a, b) => a - b)

  return (
    <Segment style={{ color: 'white' }}>
      <Header as='h2' textAlign='center'>{lesson?.name}</Header>
      <List>
        {lesson?.links && !!lesson?.links.length && (
          <List.Item>
            <b style={{ color: 'white' }}>
              <Trans i18nKey='lesson.details.links'>Links</Trans>
            </b>
            <List.List>
              {lesson?.links && lesson?.links.map((link) => link?.links.map(docu =>
                <a href={docu.url} key={docu.title} target='_blank' rel='noreferrer'>
                  {docu.title}
                </a>))}
            </List.List>
          </List.Item>)}
        {!!grades?.length &&
          <List.Item>
            <Trans i18nKey='activities.details.grade'>Grade:</Trans> &nbsp;
            {grades.length === 1 ? (grades[0] === 0 ? 'K' : grades[0]) : `${grades[0] === 0 ? 'K' : grades[0]} - ${grades[grades.length - 1]}`}
          </List.Item>}
        {!!lesson?.products?.length && (
          <List.Item>
            <Trans i18nKey='activities.details.compatibles'>Compatible products</Trans>
            <List.List style={{ color: 'white' }}>
              {lesson.products.map(product => (
                <List.Item key={product?.product?.name}>{product?.product?.name}</List.Item>
              ))}
            </List.List>
          </List.Item>)}
      </List>
    </Segment>
  )
}

const MobileLessonDetail = ({ product }) => {
  const { slug } = useParams('slug')
  return (
    <>
      {product === 'edurobots' ? <EduLessonDetail slug={slug} /> : <NonEduLessonDetail slug={slug} />}
    </>
  )
}

export default MobileLessonDetail
